<ion-menu contentId="main-content" type="overlay">
	<ion-content>
		<ion-list lines="none" id="inbox-list" class="ion-no-margin ion-no-padding">
			<ion-item class="logo-item">
				<ion-img src="assets/img/scouz-pro-white.png"></ion-img>
			</ion-item>
			<ion-item  class="ion-display-flex ion-justify-content-between">
				@if (sharedService.universes.length > 1) {
					<ion-select aria-label="{{'general.universe'}}" value="{{currentUniverse?.id_universe}}" (ionChange)="changeUniverse($event)" label="{{'general.universe' | translate}}">
						@for (universe of sharedService.universes; track universe.id_universe) {
							<ion-select-option value="{{universe.id_universe}}">{{universe.name}}</ion-select-option>
						}
					</ion-select>
				}
				@else if (currentUniverse) {
					<span class="unv-{{currentUniverse.id_universe}}">{{currentUniverse.name}}</span>
				}
			</ion-item>
		</ion-list>
		<ion-list>
			@for (page of pages; track $index) {
				@if (page.access <= (ACCESS_LEVEL || PLATFORM_ACCESS_LEVEL) && page.canRender) {
					@if (page.isSection) {
						<ion-item-divider>{{page.title}}</ion-item-divider>
					}
					@else {
						<ion-item [button]="true" [color]="page.isActive ? 'primary' : ''" (click)="navigateTo(page.router)">
							@if (page.icon) {
								<mat-icon aria-hidden="true" aria-label="{{page.title}}" fontSet="{{sharedService.iconsFontSet}}">{{page.icon}}</mat-icon>
							}
							<ion-label>{{page.title}}</ion-label>

							@if (page.isChat && !chatService.hasBeenSeen()) {
								<mat-icon slot="end" class="sm-icon" fontSet="{{sharedService.iconsFontSet}}">notifications</mat-icon>
							}
						</ion-item>
					}
				}
			}
			@if (version) {
				<ion-item class="version-item">
					<ion-label>{{'sidebar.version' | translate}} {{version.code}}</ion-label>
				</ion-item>
			}
		</ion-list>
	</ion-content>
</ion-menu>